<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-bg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">База клиентов</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path d="M16.5 1.4L15.1 0L8.5 6.6L1.9 0L0.5 1.4L7.1 8L0.5 14.6L1.9 16L8.5 9.4L15.1 16L16.5 14.6L9.9 8L16.5 1.4Z" fill="#7C7C7C"/>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ $t('search') }}</label>
            <input class="large" type="text" :placeholder="$t('search')" v-model="search" v-on:keyup.enter="getClients()">
          </div>
          <table class="table table-striped table-scrolling p-r-0">
            <thead>
            <tr>
              <th scope="col" class="small-first-th">№</th>
              <th scope="col"></th>
              <th scope="col">{{ $t('FIO') }}</th>
              <th scope="col">E-mail</th>
              <th scope="col">{{ $t('phone') }}</th>
            </tr>
            </thead>
            <tbody class="vertical-scroll">
            <tr v-for="(item, index) in clients" v-bind:key="item.id">
              <th scope="row" class="small-first-th">
                {{ index + 1}}
              </th>
              <th scope="row">
                <label class="table__selected">
                  <input type="checkbox" v-model="selectedClient" :value="item.id">
                  <span class="checkmark"></span>
                </label>
              </th>
              <td>{{ (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '') }}</td>
              <td>{{ item.email }}</td>
              <td class="check-phone pointer" v-if="item.phone" @click="openPhones">
                <img src="@/assets/icon/check.svg">
                <div class="phone-dropdown">
                  <p class="phone" v-for="phone in item.phone.split(',')">
                    {{ filteredPhone(phone) }}
                  </p>
                </div>
              </td>
              <td v-else>
                <img src="@/assets/icon/cross.svg">
              </td>
            </tr>
            </tbody>
          </table>
          <div class="form-row justify-content-center" v-if="clients.length < cClient && search === null || search === ''">
            <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
          </div>
          <div class="form-row justify-content-end">
            <a class="btn" @click="setClientsToSegment">Добавить в сегмент</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'add-client-in-segment-modal',
  props: ['segment'],
  data: function(){
    return{
      id: this.segment,
      selectedClient: [],
      clients: [],
      cClient: 0,
      errors: [],
      search: null,
      dynamicSearch: {
        searchVarChar: {},
        searchDouble: {},
        searchDate: {},
      },
      page: 1
    }
  },
  mounted() {
    this.getClients();
  },
  watch: {
    segment: function(val){
      if(val){
        this.id = val;
      }
    },
  },
  methods: {
    filteredPhone: function(p){
      let result;

      result = p.substr(0, 2) + ' ' + p.substr(2, 10);
      result = result.substr(0, 6) + ' ' + p.substr(5, 12);
      result = result.substr(0, 7) + '' + p.substr(5, 12);
      result = result.substr(0, 10) + '-' + p.substr(8, 12);
      result = result.substr(0, 13) + '-' + p.substr(10, 12);
      return result;
    },
    openPhones: function(e){
      var el = e.target;

      if(!el.classList.contains('check-phone')){
        el = el.parentElement;
      }

      if(el.classList.contains('check-phone')){
        var dropdown = el.querySelector('.phone-dropdown');
        if(dropdown.classList.contains('active')){
          dropdown.classList.remove('active');
        }else{
          dropdown.classList.add('active');
        }
      }
    },
    nextPage: function(){
      this.page++;
      this.getClients();
    },
    getClients: function(){
      this.isLoading = true;
      var data = {
        segment_id: '',
        search: this.search,
        page: this.page,
        dynamicSearch: this.dynamicSearch,
      }
      axios.post('getClients', data).then(response => {
        var status = response.data.status;
        if(status){
          this.clients = response.data.clients;
          this.cClient = response.data.cClient;
          this.isLoading = false;
        }
      });
    },
    setClientsToSegment: function(){
      if(this.selectedClient.length <= 0){
        this.$toast.error('Необходимо выбрать минимум 1 клиента');
      }
      var data = {
        segment_id: this.id,
        clients: this.selectedClient
      }
      axios.post('setClientsToSegment', data).then(response => {
        var status = response.data.status;
        if(status){
          this.$toast.success(response.data.message);
          this.$root.$emit('viewSegmentUpdateClients');
          this.close();
          this.isLoading = false;
        }
      });
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}
</style>